module.exports = __webpack_public_path__ + "static/media/hktimes.7e622352.png";